import { useMutation } from '@tanstack/react-query'

import { createEvidenceRequest } from '@src/api'
import { DefaultApiCreateEvidenceRequestRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks'

export const useCreateEvidenceRequest = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: ({
      organizationId,
      paymentReferenceId,
    }: DefaultApiCreateEvidenceRequestRequest) =>
      createEvidenceRequest(axiosInstance, {
        organizationId,
        paymentReferenceId,
      }),
  })
}
